interface ScoreBadgeProps {
  value: number;
  size?: "sm" | "md" | "lg";
}

export default function ScoreBadge({ value, size = "md" }: ScoreBadgeProps) {
  const sizeClass =
    size === "sm"
      ? "text-[11px] px-1.5 py-0.5"
      : size === "lg"
      ? "text-base px-2.5 py-1"
      : "text-xs px-2 py-1";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md bg-accent-500 text-background-50 font-semibold ${sizeClass}`}
    >
      <i className="ri-star-fill text-[0.85em]"></i>
      {value.toFixed(1)}
    </span>
  );
}